import { render, staticRenderFns } from "./SolicitudGuiasAsignadas.vue?vue&type=template&id=53554da0&scoped=true"
import script from "./SolicitudGuiasAsignadas.vue?vue&type=script&lang=js"
export * from "./SolicitudGuiasAsignadas.vue?vue&type=script&lang=js"
import style0 from "./SolicitudGuiasAsignadas.vue?vue&type=style&index=0&id=53554da0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53554da0",
  null
  
)

export default component.exports